export * from "./ConsultationRating";
